import { RespImage } from '@/app/_components/core/resp-image';
import type { AccordionCardListCard } from '@/app/_components/shared/accordion-card-list/accordion-card-list.types';

export function AccordionCardListImage({
  card,
}: {
  card: AccordionCardListCard;
}) {
  const candidates = card.image?.srcsetCandidates
    ? Array.isArray(card.image.srcsetCandidates)
      ? card.image.srcsetCandidates
      : Object.values(card.image.srcsetCandidates).flatMap((arr) => arr ?? [])
    : [];

  if (candidates.length === 0) {
    return <div className="aspect-4/3 overflow-hidden rounded-accordion-card-list-media-radius bg-muted" />;
  }

  const altText =
    card.image?.altText ?? card.persons.map((p) => p.name).join(', ');

  return (
    <div className="aspect-4/3 overflow-hidden rounded-accordion-card-list-media-radius bg-muted">
      <RespImage
        srcsetCandidates={candidates}
        alt={altText}
        title={card.image?.title ?? undefined}
        className="size-full object-cover"
      />
    </div>
  );
}
